/* eslint-disable camelcase */
import { decamelizeKeys } from '../lib';
import { getBackVersion } from '../config';
import { CardAddress, CardSnapshot } from '../models';
import api from './api';

const getCards = (): Promise<CardSnapshot[]> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/cards`,
    });
};

const removeCard = (cardId: number): Promise<void> => {
    return api.request({
        method: 'DELETE',
        url: `${getBackVersion()}/cards/` + cardId,
    });
};

const createCard = (
    publicKeyId: number,
    encryptedData: string
): Promise<CardSnapshot> => {
    return api.request({
        method: 'POST',
        action: 'CREATE_CREDIT_CARD',
        url: `${getBackVersion()}/cards`,
        data: decamelizeKeys({
            publicKeyId,
            value: encryptedData,
        }),
    });
};

const updateCardAddress = (
    cardId: number,
    cardAddress: CardAddress
): Promise<CardSnapshot> => {
    return api.request({
        method: 'PUT',
        url: `${getBackVersion()}/cards`,
        data: {
            card_id: cardId,
            card_address: decamelizeKeys(cardAddress),
        },
    });
};

export default { getCards, removeCard, createCard, updateCardAddress };
